<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <router-link class="profile-link" active-class :exact="true" :to="{name: 'AddGroup'}">
        <v-btn color="#6A158E" dark v-if="permitObj.g_add">+ Add Group</v-btn>
      </router-link>

      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <group-table :perms="permitObj"></group-table>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import GroupTable from "../../../components/classes/GroupTable.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
  name: "Classes",
  components: { GroupTable, BreadCrumbs },
  data() {
    return {
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard"
          }
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: "Classes"
          }
        }
      ],
      permitObj : {}
    };
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "Groups";
      this.permitObj = getPermitObjects(links, pathName)
    }
  },
  mounted() {
    this.getPermittedArray();
  },
};
</script>

<style scoped>
</style>